import styled from '@emotion/styled'

export const BannerText = styled.span`
  color: #1c212e;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 14px; /* 100% */
`
